import React, { useEffect, useState } from 'react'
import { useObject } from 'react-firebase-hooks/database'
import OfficeBearerModal from 'src/components/OfficeBearerModal'
import OrganisingCommitteeModal from 'src/components/OrganisingCommiteeModal'
import styled from 'styled-components'
import ChatSection from '../components/ChatSection'
import FacultySide from '../components/FacultySide'
import { LiveCheckInButton } from '../components/LiveCheckInButton'
import LoadIcon from '../components/LoadIcon'
import PageWithBg from '../components/PageWithBg'
import SideAgenda from '../components/SideAgenda'
import config from '../config'
import { getLiveCheckInSessionDb, HallOneChatDb, HallOneDb, HallTwoChatDb, HallTwoDb } from '../firebaseConfig'
import AuditoriumScreen from'../images/backdrops/auditorium-screen.png'
import banner from '../images/backdrops/auditorium_banner.png'
import liveStream from '../images/icons/live-tv.png'
import replayIcon from '../images/icons/replay-icon.png'
import screen from '../images/backdrops/auditorium_screen.png'
import { COLORS, SIZES } from '../styles/theme'
import Amplitude from '../utils/amplitudeHelper'
import { useAutoMute } from '../utils/useAutoMute'

const Page = styled.div`
  overflow: hidden;
  .content {
    ${config.layout.auditoriumVid}
    position: absolute;

    iframe {
      height: 100%;
      width: 100%;
    }
  }
  .chat {
    max-width: 350px;
    position: fixed;
    padding-top: ${SIZES.navHeight};
    top: 0;
    left: 67%;
    bottom: 0;
    right: 5%;
    z-index: 30;
  }
  .attendance {
    /* border: 1px solid red; */
    position: fixed;
    bottom: 17%;
    left: 7%;
    right: 37%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
  }
  .action-button {
    display: inline-block;
    background: #f87949;
    border-radius: 48px;
    border: 1px solid white;
    text-decoration: none;
    color: ${COLORS.hotButtonText};
    padding: 6px 24px;
    font-weight: 800;
    font-size: 80%;
    cursor: pointer;
    height: 100%;
    /* min-width: 150px; */
  }

  #check-in-btn {
    height: 52px;
    position: fixed;
    bottom: 10%;
    left: 7%;
    right: 37%;
    margin: 0 auto;
    background: #f85d49;
    box-shadow: 0 4px 0 1px #c32915;
    transition: 500ms ease;
    &:hover {
      cursor: pointer;
      bottom: 10.5%;
      box-shadow: 0 6px 0 1px #c32915;
    }
  }
  #sponsors {
    display: block;
    position: fixed;
    top: ${SIZES.navHeight};
    left: 13%;
    right: 43%;
    img {
      display: block;
      max-width: 1000px;
      margin: 0 auto;
    }
  }
  #tooltip-container {
    background-color: #000;
    padding: 18px;
    position: fixed;
    top: 20%;
    bottom: 28%;
    left: 1%;
    right: 86%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .tooltip-text {
    color: #fff;
    font-weight: 500;
    font-size: 14px;
    text-align: center;
    margin-top: 12px;
  }
  .toggle-live-btn {
    cursor: pointer;
    animation: bounce 1500ms infinite;
  }
`

export default function AuditoriumPage({ liveUrl, hallNumber, currentUser }) {
  useAutoMute()
  const [loading, setLoading] = useState(true)
  const [sidebar, setSidebar] = useState(false)
  const [watchPlayBack, setWatchPlayBack] = useState(false)
  const [facultySide, setFacultySide] = useState(false)
  const [officeBearerModal, setOfficeBearerModal] = useState(false)
  const [organisingCommitteeModal, setOrganisingCommitteeModal] = useState(false)
  const [videoUrl, setVideoUrl] = useState(liveUrl)

  // live check in session firebase
  const [snapshot, snapshotLoading, snapshotError] = useObject(getLiveCheckInSessionDb(hallNumber))

  useEffect(() => {
    document.title = `${config.eventName} | Conference`
  }, [])

  useEffect(() => {
    Amplitude.visit(`Lecture Hall ${hallNumber === 1 ? 'A' : 'B'}`)
  }, [currentUser.id, hallNumber])

  const toggleOrganisingCommittee = () => {
    if (organisingCommitteeModal === false) {
      Amplitude.clickOrganisingCommittee()
    }
    setOrganisingCommitteeModal(!organisingCommitteeModal)
  }

  const toggleOfficeBearer = () => {
    if (officeBearerModal === false) {
      Amplitude.clickOfficeBearer()
    }
    setOfficeBearerModal(!officeBearerModal)
  }

  const toggleSidebar = () => {
    if (sidebar === false) {
      Amplitude.clickProgrammeButton()
    }
    setSidebar(!sidebar)
  }
  const toggleFacultySide = () => {
    if (facultySide === false) {
      Amplitude.clickFaculty()
    }
    setFacultySide(!facultySide)
  }

  const handlePlayback = (session) => {
    if (session.vimeo_id !== '') {
      Amplitude.watchPlayback(session.id)
      setVideoUrl(`https://player.vimeo.com/video/${session.vimeo_id}`)
      setWatchPlayBack(true)
      setSidebar(false)
      setLoading(true)
    } else if (session.redirect_url) {
      console.log(session.redirect_url)
    }
  }
  const playLiveStream = () => {
    setVideoUrl(liveUrl)
    setLoading(true)
    setWatchPlayBack(false)
  }

  return (
    <>
      {loading && <LoadIcon />}
      <Page>
        {sidebar && (
          <SideAgenda handlePlayback={handlePlayback} open={sidebar} toggleSidebar={toggleSidebar} hallNumber={hallNumber} currentUser={currentUser} />
        )}
        <OfficeBearerModal showOfficeBearer={officeBearerModal} setShowOfficeBearer={toggleOfficeBearer} />
        <OrganisingCommitteeModal showOrganisingCommittee={organisingCommitteeModal} setShowOrganisingCommittee={toggleOrganisingCommittee} />
        <FacultySide open={facultySide} toggleSidebar={toggleFacultySide} />
        <PageWithBg bgImg={config.assets.auditorium1.landscape}>
          <div className="content">
            <img src={AuditoriumScreen} alt="Auditotium Screen Banner" width="100%"></img>
            {/* <iframe
              title="Live Broadcast"
              src={`${videoUrl}?autoplay=1`}
              allow="autoplay; fullscreen"
              allowFullScreen
              frameBorder="0"
              onLoad={() => {
                setLoading(false)
              }}
            /> */}
          </div>
          <div className="chat h-100">
            <ChatSection
              currentUser={currentUser}
              firebaseDb={hallNumber === 1 ? HallOneDb : HallTwoDb}
              chatDb={hallNumber === 1 ? HallOneChatDb : HallTwoChatDb}
            />
          </div>
          <LiveCheckInButton snapshot={snapshot} snapshotLoading={snapshotLoading} snapshotError={snapshotError} />
        </PageWithBg>
      </Page>
    </>
  )
}
